import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Login_API } from "./environment";
import "./login.css";

export default function Login() {
  const navigate = useNavigate();
  const { setUserData } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr("");

    if (!username || !password) {
      setErr("Please enter username and password");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(Login_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      console.log("Response Status:", res.status); // Debug: Check status
      if (!res.ok) {
        const errorData = await res.json();
        console.log("Error Data:", errorData); // Debug: Log error
        throw new Error(errorData.detail || "Login failed");
      }

      const data = await res.json();
      console.log("Response Data:", data); // Debug: Log response

      if (!data.access_token) {
        setErr("No token received");
        setLoading(false);
        return;
      }

      // Save to AuthContext
      setUserData({
        access_token: data.access_token,
        token_type: data.token_type,
        username: data.username,
        id: data.id,
      });

      console.log("userData set, navigating to /jobs"); // Debug: Confirm navigation
      navigate("/jobs");
    } catch (error) {
      console.error("Login Error:", error.message); // Debug: Log error
      setErr(error.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <h2>Admin Login</h2>
        <div className="input-wrapper">
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="username"
            autoComplete="username"
            required
          />
        </div>
        <div className="input-wrapper">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="password"
            autoComplete="current-password"
            required
          />
        </div>
        {err && <div className="error">{err}</div>}
        <button type="submit" disabled={loading} className="primary-btn">
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
}